import Keycloak from 'keycloak-js'

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  url: import.meta.env.VITE_APP_KEYCLOAK_URL,
  realm: import.meta.env.VITE_APP_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_APP_KEYCLOAK_CLIENTID
});

keycloak.onTokenExpired = () => {
  keycloak.updateToken(300) // Tries to refresh the token if it expires within 300 seconds
    .then(() => console.log("Token successfully refreshed"))
    .catch(() => console.error("Failed to refresh token"));
};

export default keycloak